export default __webpack_public_path__ + "static/media/Deo-Oriental.e762dca1.jpg";